<template>
  <el-dialog title="导入标本" :visible.sync="visible">
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="80px">
      <el-form-item label="检验项目" prop="itemInfo">
        <el-select
          v-model="dataForm.itemInfo"
          filterable
          remote
          reserve-keyword
          placeholder="请输入服务项目名称"
          :remote-method="remoteMethod"
          :loading="loading"
          value-key="id"
          clearable>
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.label"
            :value="item.obj">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择文件" prop="fileList">
        <el-upload
          ref="upload"
          :action="actionUrl"
          :file-list="dataForm.fileList"
          :auto-upload="false"
          :on-change="handleChange"
          :on-success="handleSuccess"
          :limit="1">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible=false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  import { getCookie } from "../util/util";

  export default {
    name: "sample-import",
    data() {
      return {
        visible: false,
        dataForm: {
          itemInfo: '',
          fileList: []
        },
        dataRule: {
          itemInfo: [
            { required: true, message: '检验项目不能为空' }
          ],
          fileList: [
            { required: true, message: '文件不能为空' }
          ]
        },
        options: [],
        loading: false
      }
    },
    computed: {
      actionUrl () {
        return process.env.API_ROOT + `/jys/hospSample/import?itemId=` + this.dataForm.itemInfo.id + `&token=${getCookie("_token")}`
      }
    },
    methods: {
      init () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.dataForm.resetFields()
        })
        this.remoteMethod('')
      },
      handleChange (file, fileList) {
        this.dataForm.fileList = fileList
        this.$refs.dataForm.clearValidate()
      },
      handleSuccess (response) {
        if (response.code === 0) {
          this.$message.success('上传成功')
          this.$emit('refreshDataList')
          this.visible = false
        } else {
          this.$message.error(response.msg)
        }
      },
      remoteMethod (query) {
        this.loading = true
        axios.get("/jys/hospSample/services", {
          params: {
            name: query
          }
        }).then((res) => {
          this.loading = false
          if (res.data.code === 0) {
            this.options = res.data.list.map(item => {
              return { id: `${item.id}`, label: `${item.itemName}`, obj: {id: item.id, itemName: item.itemName} }
            })
          }
        })
      },
      dataFormSubmit () {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            this.$refs.upload.submit()
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sample-import.vue